import React from 'react';
export function PrintIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 1H4v5H0v11a2 2 0 002 2h2.586l4.121 4.121a3 3 0 002.121.879H20v-5h2a2 2 0 002-2V6h-4V1zm-9 21v-5H6v-4h12v9h-7zM4 11v6H2V8h20v9h-2v-6H4zm14-5V3H6v3h12z"
  }));
}